import React from "react";
import { useApp } from "@/state/AppContext";
import { Button } from "@/components/ui/button";
import { AsLogo } from "@/components/AsLogo";

// Shown on the admin host when someone is SIGNED IN but is not a platform admin. It must NOT
// redirect: the admin router funnels every unknown path to `/platform`, so a `<Navigate to="/..">`
// to a route that does not exist here (e.g. `/account`) bounces straight back to `/platform` and
// the guard sends them here again — the blank-page redirect loop. A terminal page that says why,
// shows which account is signed in, and offers a way out (sign out → `/login`) is the fix.
export default function NoAccess() {
  const { auth, signOut, t } = useApp();
  const email = auth?.identity?.email || auth?.identity?.display_name || "";
  // Translated sentence with the account emphasised: split the copy around the {email} slot.
  const MARK = "\u0001";
  const [before, after = ""] = t("noAccess.adminBody", { email: MARK }).split(MARK);

  return (
    <div className="grid min-h-screen place-items-center px-6" data-testid="no-access">
      <div className="flex w-full max-w-sm flex-col items-center gap-4 text-center">
        <AsLogo />
        <h1 className="text-lg font-semibold text-foreground">{t("noAccess.adminTitle")}</h1>
        <p className="text-sm text-muted-foreground">
          {before}
          <span className="font-medium text-foreground">{email}</span>
          {after}
        </p>
        <Button
          type="button"
          variant="outline"
          onClick={() => signOut()}
          data-testid="no-access-signout"
        >
          {t("common.signOut")}
        </Button>
      </div>
    </div>
  );
}
